import { Switch } from '@vkontakte/vkui';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { offlineModeEnabled } from 'reactApp/appHelpers/featuresHelpers/features/offlineModeFakedoor';
import { BREAKPOINT_MD } from 'reactApp/constants/breakpoints';
import { useMinWidthBreakpoint } from 'reactApp/hooks/responsiveness/useMinWidthBreakpoint';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';

import styles from './OfflineModeButton.css';

interface Props {
    isReady: boolean;
}

export const OfflineModeButton = ({ isReady }: Props) => {
    const dispatch = useDispatch();
    const [largeBreakpointHit] = useMinWidthBreakpoint(BREAKPOINT_MD);
    const isMidi = !largeBreakpointHit;

    const onFakedoorClick = useCallback(() => {
        emitAnalyticEvent(AnalyticEventNames.OFFLINE_MODE_CLICK);
        dispatch(
            showSnackbarAction({
                id: 'fake-offline-click',
                text: 'Этой функции пока нет. Теперь знаем, что нужна, благодаря вам',
                type: SnackbarTypes.success,
                closable: true,
            })
        );
    }, [dispatch]);

    if (isMidi || !isReady || !offlineModeEnabled) {
        return null;
    }

    return (
        <div className={styles.switcherGroup}>
            <Switch name="offline-mode" checked={false} className={styles.switcher} readOnly onClick={onFakedoorClick} />
            <span>Оффлайн-режим</span>
        </div>
    );
};
